"use client";
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  MessageCircle,
  Send,
  User,
  Calendar,
} from "lucide-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { motion } from "motion/react";
import { OptimizedImage } from "../../components/common/OptimizedImage";
import { Button } from "../../components/ui/button";
import { useAppDispatch, useAppSelector } from "../../_hooks/hooks";
import { ICMS, ISettings } from "../home/homeModel";
import Link from "next/link";
import { useRouter } from "next/navigation";
import {
  getAllCMSByURL,
  getAllMetaData,
  insertInquiry,
} from "../home/services/home.services";
import { setCMSList, setMetaDetails } from "../home/homeSlice";
import { ErrorToast } from "../../components/common/Toast";
import dynamic from "next/dynamic";
const Preloader = dynamic(() =>
  import("../../components/Preloader").then((mod) => mod.Preloader),
);
import {
  createLookupObject,
  formatPhoneForDisplay,
  cleanPhoneForTel,
} from "../../_helper/helper";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { useCallback, useEffect, useState } from "react";

export default function Contact({ initialCMS }: { initialCMS?: any[] }) {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const loading = useAppSelector((state) => state.home.loading);
  const formLoading = useAppSelector((state) => state.home.formLoading);
  const BannerList = useAppSelector((state) => state.home.BannerList);
  const SettingList = useAppSelector((state) => state.home.SettingList);
  const PropertyList = useAppSelector((state) => state.property.PropertyList);

  const [lookUpCMSData, setLookUpCMSData] = useState<Record<string, ICMS>>({});

  // Map state
  const [mapOpen, setMapOpen] = useState(false);
  const [activeMapURL, setActiveMapURL] = useState("");

  const handleOpenMap = useCallback((mapUrl: string) => {
    setActiveMapURL(mapUrl);
    setMapOpen(true);
  }, []);

  const handleMapClose = useCallback(() => {
    setMapOpen(false);
    setActiveMapURL("");
  }, []);

  const CMSList = initialCMS;

  const Settings: Record<string, ISettings> = SettingList?.reduce(
    (acc, item) => {
      acc[item?.SettingKey] = item;
      return acc;
    },
    {} as Record<string, ISettings>,
  );

  const PhoneNo = Settings?.["PhoneNo"]?.SettingValue;
  const PhoneNo2 = Settings?.["PhoneNo2"]?.SettingValue;
  const PhoneNo3 = Settings?.["PhoneNo3"]?.SettingValue;
  const EmailID = Settings?.["EmailID"]?.SettingValue;
  const EmailID2 = Settings?.["EmailID2"]?.SettingValue;
  const EmailID3 = Settings?.["EmailID3"]?.SettingValue;

  const WhatsAppNo = Settings?.["WhatsAppNo"]?.SettingValue;
  const WhatsAppNo2 = Settings?.["WhatsAppNo2"]?.SettingValue;
  const WhatsAppNo3 = Settings?.["WhatsAppNo3"]?.SettingValue;
  const whatsappPhone = WhatsAppNo ? WhatsAppNo.replace(/\D+/g, "") : "";
  const whatsappPhone2 = WhatsAppNo2 ? WhatsAppNo2.replace(/\D+/g, "") : "";
  const whatsappPhone3 = WhatsAppNo3 ? WhatsAppNo3.replace(/\D+/g, "") : "";
  const whatsappLink = `https://wa.me/${whatsappPhone}?text=${encodeURIComponent("Hello, I’d like to know more details.")}`;
  const whatsappLink2 = `https://wa.me/${whatsappPhone2}?text=${encodeURIComponent("Hello, I’d like to know more details.")}`;
  const whatsappLink3 = `https://wa.me/${whatsappPhone3}?text=${encodeURIComponent("Hello, I’d like to know more details.")}`;

  const banner: any =
    BannerList?.find((banner: any) => banner?.BannerType === "Contact") || {};

  useEffect(() => {
    if (CMSList && CMSList?.length > 0) {
      setLookUpCMSData(createLookupObject(CMSList, "Name"));
    }
  }, [CMSList, initialCMS]);

  // const resorts = [
  //   {
  //     name: "Kavish Jawai",
  //     location: "Jawai Perwa, Rajasthan",
  //     phone: "+91 98765 43210",
  //     email: "jawai@kavishhotels.com",
  //     image:
  //       "https://images.unsplash.com/photo-1646358047813-055e7f42c7ea?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsZW9wYXJkJTIwd2lsZGxpZmUlMjBzYWZhcml8ZW58MXx8fHwxNzY4OTY5NzYwfDA&ixlib=rb-4.1.0&q=80&w=1080",
  //   },
  //   {
  //     name: "Kavish Gir",
  //     location: "Sasan Gir, Gujarat",
  //     phone: "+91 98765 43211",
  //     email: "gir@kavishhotels.com",
  //     image:
  //       "https://images.unsplash.com/photo-1624341679500-b3ffeca0df59?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxnaXIlMjBmb3Jlc3QlMjB3aWxkbGlmZXxlbnwxfHx8fDE3Njg5Njk3NjF8MA&ixlib=rb-4.1.0&q=80&w=1080",
  //   },
  //   {
  //     name: "Kavish Kumbhalgarh",
  //     location: "Kumbhalgarh, Rajasthan",
  //     phone: "+91 98765 43212",
  //     email: "kumbhalgarh@kavishhotels.com",
  //     image:
  //       "https://images.unsplash.com/photo-1762498509471-58f3482089d1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxrdW1iaGFsZ2FyaCUyMGZvcnQlMjBoaWxsc3xlbnwxfHx8fDE3Njg5Njk3NjF8MA&ixlib=rb-4.1.0&q=80&w=1080",
  //   },
  //   {
  //     name: "Kavish Udaipur",
  //     location: "Udaipur, Rajasthan",
  //     phone: "+91 98765 43213",
  //     email: "udaipur@kavishhotels.com",
  //     image:
  //       "https://images.unsplash.com/photo-1622018135960-249abd263aeb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1ZGFpcHVyJTIwbGFrZSUyMHBhbGFjZXxlbnwxfHx8fDE3Njg5Njk3NjB8MA&ixlib=rb-4.1.0&q=80&w=1080",
  //   },
  // ];

  const formik: any = useFormik({
    initialValues: {
      FirstName: "",
      LastName: "",
      Email: "",
      MobileNo: "",
      Message: "",
      PropertyURL: "",
      InquiryType: "",
    },
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: Yup.object({
      FirstName: Yup.string().trim().required("First Name is required"),
      LastName: Yup.string().trim().required("Last Name is required"),
      MobileNo: Yup.string()
        .required("Mobile number is required")
        .matches(/^[0-9]{10}$/, "Mobile number is not valid"),
      Email: Yup.string()
        .required("Email is required")
        .test("is-email-required", "Email is not valid", function (value) {
          if (!value) {
            return true;
          }
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          return emailRegex.test(value);
        }),
      PropertyURL: Yup.string().required("Resort is required"),
      InquiryType: Yup.string().required("Inquiry Type is required"),
    }),
    onSubmit: async (
      values,
      {
        // setSubmitting,
        resetForm,
      },
    ) => {
      const payload = {
        FirstName: values?.FirstName ? values?.FirstName : "",
        LastName: values?.LastName ? values?.LastName : "",
        Email: values?.Email ? values?.Email : "",
        MobileNo: `${values?.MobileNo}`,
        Remarks: values?.Message ? values?.Message : "",
        PropertyURL: values?.PropertyURL ? values?.PropertyURL : "",
        InquiryType: values?.InquiryType ? values?.InquiryType : "",
      };
      try {
        const response = await dispatch(insertInquiry(payload));
        if (response.meta.requestStatus === "fulfilled") {
          resetForm();
          router.push("/thankyou/");
        } else {
          ErrorToast("Error sending message!");
        }
      } catch (error) {
        // console.log("error", error);
      }
    },
  });

  return (
    <>
      {loading && <Preloader />}
      <div className="min-h-screen bg-white text-md">
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-end justify-center overflow-hidden">
          <div
            className="absolute inset-0 z-0"
            style={{
              backgroundImage: `url('${banner?.BannerImage}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70" />
          </div>

          <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 mt-25 mb-15">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              {banner?.SubTitle && (
                <div className="inline-block px-6 py-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-full mb-8">
                  <p className="text-[#C9A962] tracking-[0.4em] text-sm">
                    {banner?.SubTitle || "CONNECT WITH US"}
                  </p>
                </div>
              )}

              <h1 className="text-white text-3xl md:text-4xl lg:text-5xl mb-8 leading-tight font-playfair">
                {/* Let's Start a<br /> */}
                <span className="text-[#C9A962]">
                  {banner?.BannerTitle || "Let's Start a Conversation"}
                </span>
              </h1>

              {banner?.Description && (
                <p
                  className="text-white/95 text-xl md:text-2xl max-w-3xl mx-auto mb-12 font-playfair"
                  dangerouslySetInnerHTML={{
                    __html: banner?.Description,
                  }}
                />
              )}

              {/* Quick Contact Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mx-auto">
                <motion.div
                  className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                >
                  <Phone className="h-12 w-12 text-[#C9A962] mx-auto mb-4" />
                  <p className="text-white/70 text-sm mb-2">Call Us</p>
                  {PhoneNo && (
                    <p className="text-white text-lg">
                      <Link
                        href={`tel:${cleanPhoneForTel(PhoneNo)}`}
                        className="notranslate"
                        translate="no"
                      >
                        {formatPhoneForDisplay(PhoneNo)}
                      </Link>
                    </p>
                  )}
                  {PhoneNo2 && (
                    <p className="text-white text-lg">
                      <Link
                        href={`tel:${cleanPhoneForTel(PhoneNo2)}`}
                        className="notranslate"
                        translate="no"
                      >
                        {formatPhoneForDisplay(PhoneNo2)}
                      </Link>
                    </p>
                  )}
                  {PhoneNo3 && (
                    <p className="text-white text-lg">
                      <Link
                        href={`tel:${cleanPhoneForTel(PhoneNo3)}`}
                        className="notranslate"
                        translate="no"
                      >
                        {formatPhoneForDisplay(PhoneNo3)}
                      </Link>
                    </p>
                  )}
                </motion.div>

                <motion.div
                  className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                >
                  <Mail className="h-12 w-12 text-[#C9A962] mx-auto mb-4" />
                  <p className="text-white/70 text-sm mb-2">Email Us</p>
                  {EmailID && (
                    <p className="text-white text-lg">
                      {" "}
                      <Link
                        href={`mailto:${EmailID || ""}`}
                        className="break-all notranslate"
                        translate="no"
                      >
                        {EmailID}
                      </Link>
                    </p>
                  )}
                  {EmailID2 && (
                    <p className="text-white text-lg">
                      {" "}
                      <Link
                        href={`mailto:${EmailID2 || ""}`}
                        className="break-all notranslate"
                        translate="no"
                      >
                        {EmailID2}
                      </Link>
                    </p>
                  )}
                  {EmailID3 && (
                    <p className="text-white text-lg">
                      {" "}
                      <Link
                        href={`mailto:${EmailID3 || ""}`}
                        className="break-all notranslate"
                        translate="no"
                      >
                        {EmailID3}
                      </Link>
                    </p>
                  )}
                </motion.div>

                <motion.div
                  className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                >
                  <MessageCircle className="h-12 w-12 text-[#C9A962] mx-auto mb-4" />
                  <p className="text-white/70 text-sm mb-2">WhatsApp</p>
                  {WhatsAppNo && (
                    <p className="text-white text-lg">
                      <Link
                        href={whatsappLink || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="notranslate"
                        translate="no"
                      >
                        {formatPhoneForDisplay(WhatsAppNo)}
                      </Link>
                    </p>
                  )}
                  {WhatsAppNo2 && (
                    <p className="text-white text-lg">
                      <Link
                        href={whatsappLink2 || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="notranslate"
                        translate="no"
                      >
                        {formatPhoneForDisplay(WhatsAppNo2)}
                      </Link>
                    </p>
                  )}
                  {WhatsAppNo3 && (
                    <p className="text-white text-lg">
                      <Link
                        href={whatsappLink3 || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="notranslate"
                        translate="no"
                      >
                        {formatPhoneForDisplay(WhatsAppNo3)}
                      </Link>
                    </p>
                  )}
                </motion.div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Contact Form Section */}
        <section className="py-10 md:py-20 bg-white relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#C9A962]/5 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#B42025]/5 rounded-full blur-3xl" />

          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="max-w-5xl mx-auto">
              {lookUpCMSData?.["Contact - Section 1 : Get In Touch"] ? (
                <div
                  className="text-center mb-16"
                  dangerouslySetInnerHTML={{
                    __html:
                      lookUpCMSData?.["Contact - Section 1 : Get In Touch"]
                        ?.Template,
                  }}
                />
              ) : (
                <div className="text-center mb-16">
                  <p className="text-[#B42025] tracking-[0.3em] mb-4 text-sm uppercase">
                    Get In Touch
                  </p>
                  <h2 className="text-2xl md:text-4xl mb-6 text-[#1A1A1A]">
                    Share Your Story With Us
                  </h2>
                  <div className="w-24 h-1 bg-[#C9A962] mx-auto mb-8" />
                  <p className="text-gray-600 text-lg max-w-2xl mx-auto text-xl">
                    Tell us about your dream getaway, and we'll help make it a
                    reality
                  </p>
                </div>
              )}
              <div className="bg-[#F9F7F4] rounded-3xl p-8 md:p-12 shadow-2xl">
                <form
                  onSubmit={formik.handleSubmit}
                  className="grid grid-cols-1 md:grid-cols-2 gap-8"
                >
                  <div>
                    <label className="flex items-center gap-2 text-gray-700 mb-3">
                      <User className="h-4 w-4 text-[#B42025]" />
                      <span>First Name *</span>
                    </label>
                    <input
                      name="FirstName"
                      type="text"
                      placeholder="Enter Your First Name"
                      className={`w-full px-6 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#B42025] transition-colors bg-white ${
                        formik.errors.FirstName && formik.touched.FirstName
                          ? "border-red-500"
                          : ""
                      }`}
                      maxLength={50}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values?.FirstName}
                    />
                  </div>
                  <div>
                    <label className="flex items-center gap-2 text-gray-700 mb-3">
                      <User className="h-4 w-4 text-[#B42025]" />
                      <span>Last Name *</span>
                    </label>
                    <input
                      name="LastName"
                      type="text"
                      placeholder="Enter Your Last Name"
                      className={`w-full px-6 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#B42025] transition-colors bg-white ${
                        formik.errors.LastName && formik.touched.LastName
                          ? "border-red-500"
                          : ""
                      }`}
                      maxLength={50}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values?.LastName}
                    />
                  </div>
                  <div>
                    <label className="flex items-center gap-2 text-gray-700 mb-3">
                      <Phone className="h-4 w-4 text-[#B42025]" />
                      <span>Phone Number *</span>
                    </label>
                    <input
                      id="MobileNo"
                      name="MobileNo"
                      type="number"
                      placeholder="+91 XXXXX XXXXX"
                      className={`w-full px-6 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#B42025] transition-colors bg-white ${
                        formik.errors.MobileNo && formik.touched.MobileNo
                          ? "border-red-500"
                          : ""
                      }`}
                      maxLength={50}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values?.MobileNo}
                    />
                  </div>
                  <div>
                    <label className="flex items-center gap-2 text-gray-700 mb-3">
                      <Mail className="h-4 w-4 text-[#B42025]" />
                      <span>Email Address *</span>
                    </label>
                    <input
                      id="Email"
                      name="Email"
                      type="email"
                      placeholder="example@gmail.com"
                      className={`w-full px-6 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#B42025] transition-colors bg-white ${
                        formik.errors.Email && formik.touched.Email
                          ? "border-red-500"
                          : ""
                      }`}
                      maxLength={50}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values?.Email}
                    />
                  </div>
                  <div>
                    <label className="flex items-center gap-2 text-gray-700 mb-3">
                      <MapPin className="h-4 w-4 text-[#B42025]" />
                      <span>Preferred Resort</span>
                    </label>
                    <select
                      id="PropertyURL"
                      name="PropertyURL"
                      className={`w-full px-6 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#B42025] transition-colors bg-white ${
                        formik.errors.PropertyURL &&
                        formik.touched.PropertyURL &&
                        "border-red-500"
                      }`}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.PropertyURL}
                    >
                      <option value={""}>Select a resort</option>
                      {PropertyList?.map((property: any) => {
                        return (
                          <option
                            value={property?.PropertyURL}
                            key={property?.PropertyURL}
                          >
                            {property?.PropertyName}
                          </option>
                        );
                      })}
                    </select>
                    {/* <select className="w-full px-6 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#B42025] transition-colors bg-white">
                        <option>Select a resort</option>
                        <option>Kavish Jawai</option>
                        <option>Kavish Gir</option>
                        <option>Kavish Kumbhalgarh</option>
                        <option>Kavish Udaipur</option>
                      </select> */}
                  </div>
                  <div className="flex-1 row-span-2">
                    <label className="flex items-center gap-2 text-gray-700 mb-3">
                      <MessageCircle className="h-4 w-4 text-[#B42025]" />
                      <span>Your Message *</span>
                    </label>
                    <textarea
                      name="Message"
                      id="message"
                      className="w-full px-6 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#B42025] transition-colors resize-none bg-white"
                      placeholder="Tell us about your travel plans, special requirements, or any questions you have..."
                      maxLength={500}
                      rows={7}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values?.Message}
                    />
                  </div>
                  <div>
                    <label className="flex items-center gap-2 text-gray-700 mb-3">
                      <Calendar className="h-4 w-4 text-[#B42025]" />
                      <span>Inquiry Type</span>
                    </label>
                    <select
                      id="InquiryType"
                      name="InquiryType"
                      className={`w-full px-6 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#B42025] transition-colors bg-white ${
                        formik.errors.InquiryType &&
                        formik.touched.InquiryType &&
                        "border-red-500"
                      }`}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.InquiryType}
                    >
                      <option value={""}>Select an inquiry type</option>
                      <option value={"Destination Wedding"}>
                        Destination Wedding
                      </option>
                      <option value={"Resort Booking"}>Resort Booking</option>
                      <option value={"General Inquiry"}>General Inquiry</option>
                      <option value={"Corporate Booking"}>
                        Corporate Booking
                      </option>
                    </select>
                    {/* <select className="w-full px-6 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#B42025] transition-colors bg-white">
                        <option>Room Booking</option>
                        <option>Destination Wedding</option>
                        <option>Corporate Event</option>
                        <option>Group Booking</option>
                        <option>General Inquiry</option>
                      </select> */}
                  </div>

                  <div className="md:col-span-2">
                    <Button
                      type="submit"
                      size="lg"
                      disabled={formLoading}
                      className="w-full bg-[#B42025] hover:bg-[#8F1A1E] text-white py-6 text-lg group"
                    >
                      <Send className="mr-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                      Send Your Message
                    </Button>
                    <p className="text-center text-gray-500 text-sm mt-4">
                      We typically respond within 24 hours
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Resort Cards */}
        <section className="py-10 md:py-20 bg-[#F9F7F4]">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            {lookUpCMSData?.[
              "Contact - Section 2 : Reach Our Resorts Directly"
            ] ? (
              <div
                className="text-center mb-16"
                dangerouslySetInnerHTML={{
                  __html:
                    lookUpCMSData?.[
                      "Contact - Section 2 : Reach Our Resorts Directly"
                    ]?.Template,
                }}
              />
            ) : (
              <div className="text-center mb-16">
                <h2 className="text-2xl md:text-4xl mb-6 text-[#1A1A1A]">
                  Reach Our Resorts Directly
                </h2>
                <p className="text-gray-600 text-xl max-w-2xl mx-auto">
                  Each property has a dedicated team ready to assist you
                </p>
              </div>
            )}

            <div
              className={
                `grid grid-cols-1` +
                (PropertyList?.length > 3
                  ? "md:grid-cols-2 lg:grid-cols-4 gap-8"
                  : "md:grid-cols-2 lg:grid-cols-3 gap-8")
              }
            >
              {PropertyList?.map((resort: any, index: number) => (
                <motion.div
                  key={index}
                  className="group"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 h-full">
                    <div className="aspect-[4/3] overflow-hidden">
                      <OptimizedImage
                        src={resort?.BannerImages}
                        alt={resort?.PropertyName}
                        className="w-full h-full group-hover:scale-110 transition-transform duration-700"
                        aspectRatio="4/3"
                      />
                    </div>
                    <div className="p-6">
                      <Link href={`/${resort?.PropertyURL || "#"}/`}>
                        <h3 className="text-xl text-[#1A1A1A] mb-2">
                          {resort?.PropertyName}
                        </h3>
                      </Link>
                      <div
                        className={`flex items-start gap-2 text-gray-600 text-sm mb-4 ${resort?.MapURL ? "cursor-pointer" : ""}`}
                        onClick={(e) => {
                          if (resort?.MapURL) {
                            e.preventDefault();
                            handleOpenMap(resort.MapURL);
                          }
                        }}
                      >
                        <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                        <span className={`hover:text-[#B42025]`}>
                          {resort?.Address}
                        </span>
                      </div>
                      <div className="space-y-3 text-sm">
                        {resort?.MobileNo && (
                          <div className="flex items-start gap-2 ">
                            <Phone
                              className="h-4 w-4 min-w-4"
                              style={{ marginTop: 3 }}
                            />
                            <div>
                              {resort?.MobileNo?.split(",")?.map(
                                (mobile: any, idx: number, arr: any[]) => {
                                  const trimmedMobile = mobile?.trim();
                                  return (
                                    <span
                                      key={idx}
                                      className="m-0 text-gray-700 hover:text-[#B42025] transition-colors"
                                    >
                                      <Link
                                        href={`tel:${cleanPhoneForTel(trimmedMobile)}`}
                                        className="notranslate"
                                        translate="no"
                                      >
                                        {formatPhoneForDisplay(trimmedMobile)}
                                        {idx < arr.length - 1 && ", "}
                                      </Link>
                                    </span>
                                  );
                                },
                              )}
                            </div>
                          </div>
                        )}
                        {resort?.EmailID && (
                          <div className="flex items-start gap-2 ">
                            <Mail
                              className="h-4 w-4 min-w-4"
                              style={{ marginTop: 3 }}
                            />
                            <div>
                              {resort?.EmailID?.split(",")?.map(
                                (email: any, idx: number, arr: any[]) => {
                                  const trimmedEmail = email?.trim();
                                  return (
                                    <p
                                      key={idx}
                                      className="m-0 text-gray-700 hover:text-[#B42025] transition-colors"
                                    >
                                      <Link
                                        href={`mailto:${trimmedEmail || ""}`}
                                        className="break-all notranslate"
                                        translate="no"
                                      >
                                        {trimmedEmail}
                                        {idx < arr.length - 1 && ", "}
                                      </Link>
                                    </p>
                                  );
                                },
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Office Hours */}
        {lookUpCMSData?.["Contact - Section 3 : Contact Us"] && (
          <section className="py-24 bg-[#1A1A1A]">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <div
                className="max-w-3xl mx-auto text-center"
                dangerouslySetInnerHTML={{
                  __html:
                    lookUpCMSData?.["Contact - Section 3 : Contact Us"]
                      ?.Template,
                }}
              />
              {/* <div className="max-w-3xl mx-auto text-center">
              <Clock className="h-16 w-16 text-[#C9A962] mx-auto mb-8" />
              <h2 className="text-white text-4xl md:text-5xl mb-6">
                We're Available
              </h2>
              <p className="text-white/80 text-xl mb-8">
                Monday - Sunday: 9:00 AM - 9:00 PM IST
                <br />
                24/7 Support for Current Guests
              </p>
              <p className="text-white/60">
                For urgent matters outside these hours, please use WhatsApp
              </p>
            </div> */}
            </div>
          </section>
        )}
      </div>

      {/* Map Popup */}
      <Dialog open={mapOpen} onOpenChange={handleMapClose}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden bg-white">
          <DialogHeader className="p-4 border-b flex flex-row items-center justify-between">
            <DialogTitle className="text-xl font-medium">
              Resort Location
            </DialogTitle>
          </DialogHeader>
          <div className="w-full h-[60vh] md:h-[70vh]">
            <iframe
              src={activeMapURL}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Resort Location Map"
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
